import type { InviteStatus } from "../types";

export const INVITE_STATUS = {
  Pending: 0,
  Used: 1,
  Expired: 2,
  Revoked: 3,
} as const satisfies Record<string, InviteStatus>;

export function inviteStatusLabel(status: InviteStatus): string {
  switch (status) {
    case INVITE_STATUS.Pending:
      return "pendente";
    case INVITE_STATUS.Used:
      return "já foi usado";
    case INVITE_STATUS.Expired:
      return "expirou";
    case INVITE_STATUS.Revoked:
      return "foi revogado";
    default:
      return "não está disponível";
  }
}
